"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _react = _interopRequireDefault(require("react"));
require("material-symbols");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Icon = exports.Icon = function Icon(_ref) {
  var _ref$outlined = _ref.outlined,
    outlined = _ref$outlined === void 0 ? false : _ref$outlined,
    glyphName = _ref.glyphName,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("i", {
    className: "material-symbols-".concat(outlined ? "outlined" : "rounded", " \n      text-xl text-[#282F44] \n      flex justify-center items-center \n      relative top-[1px] ").concat(className)
  }, glyphName);
};